import React, { useContext } from 'react';

export const ErrorContext = React.createContext({
    error: null,
    setError: () => {}
});

export const useError = () => useContext(ErrorContext);
